import { create } from 'zustand';

interface ProfanityState {
  isModalOpen: boolean;
  openProfanityModal: () => void;
  closeProfanityModal: () => void;
}

export const useProfanityStore = create<ProfanityState>((set) => ({
  isModalOpen: false,
  openProfanityModal: () => set({ isModalOpen: true }),
  closeProfanityModal: () => set({ isModalOpen: false }),
}));

export const isProfanityError = (error: any): boolean => {
  return error?.response?.data?.code === 'PROFANITY_DETECTED';
};
